import { getAppNameFromDomain } from 'core/common/utils/getAppNameFromDomain';
import { FunnelSettingsServiceInterface } from './interfaces';

type FunnelSettingsConfig = {
  domainUrl: string;
  funnelPlatform: string;
};

export class FunnelSettingsService implements FunnelSettingsServiceInterface {
  private domainUrl = '';
  private projectId = 'unknown';
  private funnelId = 'unknown';
  private funnelName = 'unknown';
  private funnelLocale = 'en';
  private flowId = 'unknown';
  private flowName = 'unknown';
  private funnelPlatform = 'unknown';
  private screenId: string | null = null;

  constructor(config: FunnelSettingsConfig) {
    this.domainUrl = config.domainUrl;
    this.funnelPlatform = config.funnelPlatform;
  }

  getDomainUrl() {
    return this.domainUrl;
  }

  getDomainName() {
    return getAppNameFromDomain(this.domainUrl) || 'unknown';
  }

  getFunnelPlatform() {
    return this.funnelPlatform;
  }

  getProjectId() {
    return this.projectId;
  }

  setProjectId(projectId: string) {
    this.projectId = projectId;
  }

  getFunnelId() {
    return this.funnelId;
  }

  setFunnelId(funnelId: string) {
    this.funnelId = funnelId;
  }

  getFunnelName() {
    return this.funnelName;
  }

  setFunnelName(funnelName: string) {
    this.funnelName = funnelName;
  }

  getFunnelLocale() {
    return this.funnelLocale;
  }

  setFunnelLocale(funnelLocale: string) {
    this.funnelLocale = funnelLocale;
  }

  getFlowId() {
    return this.flowId;
  }

  setFlowId(flowId: string) {
    this.flowId = flowId;
  }

  getFlowName() {
    return this.flowName;
  }

  setFlowName(flowName: string) {
    this.flowName = flowName;
  }

  getScreenId() {
    return this.screenId;
  }

  setScreenId(screenId: string) {
    this.screenId = screenId;
  }

  hasFunnelContext() {
    return this.funnelId !== 'unknown' && this.flowId !== 'unknown';
  }

  excludeFunnels(funnelNames: string[]) {
    return funnelNames.includes(this.funnelName);
  }
}
